<template>
    <div class="report-id">
        <div class="patient-id">
            <label for="patient-id" class="label">{{ $translate('patient_id') }}: </label>
            <div class="input-container">
                <input id="patient-id" v-model="patientIdInput" />
                <label for="patient-id" class="icon"><i class="fa fa-pencil"></i></label>
            </div>
        </div>

        <div class="treatment-id">
            <label for="treatment-id" class="label"> {{ $translate('treatment_id') }}: </label>
            <div class="input-container">
                <input id="treatment-id" v-model="treatmentIdInput" />
                <label for="treatment-id" class="icon"><i class="fa fa-pencil"></i></label>
            </div>
        </div>

        <div class="start-date">
            <span class="label"> {{ $translate('start_date') }}: </span>
            <span class="input-container">
                {{ formattedDate }}
            </span>
        </div>
    </div>
</template>

<script>
import moment from 'moment/moment'
import { mapState } from 'vuex'

export default {
    name: 'ReportId',
    props: {
        patientId: {
            type: String,
            required: true
        },
        treatmentId: {
            type: String,
            required: true
        },
        treatmentStartDate: {
            type: String,
            required: true
        }
    },
    data: () => ({
        patientIdInput: '',
        treatmentIdInput: ''
    }),
    computed: {
        ...mapState({
            locale: state => state.locale.locale
        }),
        formattedDate() {
            const momentDate = moment(this.treatmentStartDate).locale(this.locale.code)

            if (momentDate.isValid()) {
                return momentDate.format('MMM DD, YYYY').toUpperCase()
            }
            return this.treatmentStartDate
        }
    },
    mounted() {
        this.patientIdInput = this.patientId
        this.treatmentIdInput = this.treatmentId
    }
}
</script>

<style lang="scss" scoped>
$active: $light-3;
$passive: $light;

.report-id {
    display: grid;
    grid-template-columns: repeat(3, minmax(min-content, auto));

    label {
        margin-bottom: 0;
        cursor: pointer;

        &.icon {
            color: $passive;

            &:hover {
                color: $active;
            }
        }
    }

    .label {
        white-space: nowrap;
    }

    .input-container {
        height: 40px;
        padding: 5px 10px;
        margin-top: 10px;
        border: solid 1px $light-3;
        border-radius: 4px;
        display: grid;
        grid-template-columns: 1fr min-content;
        align-items: center;
        font-weight: 500;

        input {
            background-color: transparent;
            border: none;
            align-self: center;
            color: $active;
            text-align: left;
            font-weight: 500;

            &:focus ~ label {
                color: $active;
            }
        }
    }

    @media screen {
        column-gap: 30px;
    }

    @media print {
        column-gap: 5px;

        .patient-id,
        .treatment-id,
        .start-date {
            padding: 5px;
            display: grid;
            grid-template-columns: auto min-content;
            align-items: center;
            gap: 5px;
            border: solid 1px $report-color;
        }

        .start-date {
            justify-content: space-between;

            .label {
                white-space: normal;
            }
            .input-container {
                white-space: nowrap;
            }
        }

        .label {
            white-space: nowrap;
        }

        .input-container {
            margin: 0;
            padding: 5px;
            border: none;
            border-radius: 0;

            input {
                grid-template-columns: 1fr;
                color: black;
            }
        }

        .icon {
            display: none;
        }
    }
}
</style>
